// extracted by mini-css-extract-plugin
module.exports = {"invalid":"CurrencyInput_invalid__r48qA"};